<template>
  <div
    :style="{
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column',
      paddingRight: '2px',
      paddingLeft: '2px',
      color: corTexto,
    }"
  >
    <button
      :style="{
        alignItems: 'center',
        marginTop: '5px',
        marginBottom: '5px',
        backgroundColor: corBotao,
        color: corTexto,
      }"
      class="btn btn-dark"
    >
      Opções de entrega
    </button>
    <br />
    <section>
      <div v-if="spinnerEndereco == false">
        <div
          style="display: -webkit-box; align-items: center"
          v-if="retirarBoolean && retirarLocalInis"
        >
          <input
            type="radio"
            id="retirarLocal"
            value="retirarLocal"
            v-model="endereco_cd"
            @click="taxaBairro(0), codigoEndereco(0)"
          />
          <label
            style="padding-left: 10px"
            for="retirarLocal"
            @click="taxaBairro(0), codigoEndereco(0)"
          >
            Retirar no Local</label
          >
        </div>
        <div v-if="!somenteRetirada">
          <ul v-for="(endereco, idx) of enderecos" :key="idx">
            <li>
              <div
                style="display: -webkit-box !important; align-items: center"
                @click="retornar_cd_endereco(endereco.cd)"
                :id="endereco.cd"
              >
                <input
                  type="radio"
                  :id="idx+'endereco'"
                  :value="idx"
                  v-model="endereco_cd"
                  @click="
                    taxaBairro(endereco.taxa),
                      codigoEndereco(endereco.cd),
                      salvarEndereco(endereco)
                  "
                />
                <label
                  style="padding-left: 10px"
                  :for="idx+'endereco'"
                  @click="
                    taxaBairro(endereco.taxa),
                      codigoEndereco(endereco.cd),
                      salvarEndereco(endereco)
                  "
                >
                  Bairro: {{ endereco.bairro }} /Rua:
                  {{ endereco.rua }} /Complemento:
                  {{ endereco.complemento }} /Referência:
                  {{ endereco.proximidade }} /Taxa:
                  {{ parseFloat(endereco.taxa).toFixed(2) }}
                </label>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="spinner-border" role="status" v-else>
        <span class="sr-only">Loading...</span>
      </div>
    </section>
    <div style="display: flex; align-items: center; justify-content: flex-end">
      <button
        style="
          align-items: center;
          margin-top: 5px;
          margin-bottom: 5px;
          margin-right: 5px;
          background-color: #006400;
        "
        class="btn btn-dark"
        @click="pushEnderecos()"
      >
        Cadastrar novo endereço
      </button>
    </div>
    <br />
    <div
      style="display: flex; justify-content: center; flex-direction: column"
      class="app"
    >
      <button
        :style="{
          alignItems: 'center',
          marginTop: '5px',
          marginBottom: '5px',
          backgroundColor: corBotao,
          color: corTexto,
        }"
        class="btn btn-dark"
      >
        Forma de pagamento
      </button>
    </div>
    <br />

    <section style="display: flex; justify-content: space-between">
      <div v-if="spinnerCartao == false">
        <ul style="display: flex; flex-direction: column">
          <li
            style="display: flex; align-items: center"
            v-for="bandeira of bandeiras"
            :key="bandeira.cd"
          >
            <input
              type="radio"
              :id="bandeira.cd"
              :value="bandeira.nm"
              v-model="pagamento"
            />
            <label style="padding-left: 10px" :for="bandeira.cd">{{
              bandeira.nm
            }}</label>
          </li>
        </ul>
        <div style="display: flex; align-items: center">
          <input
            type="radio"
            id="dinheiro"
            value="dinheiro"
            v-model="pagamento"
          />
          <label style="padding-left: 10px" for="dinheiro"> Dinheiro</label>
        </div>
        <div v-if="pagamento == 'dinheiro'">
          <label for="dinheiro">Troco para:</label>
          <div style="display: flex">
            <input
              style="width: 100px"
              type="number"
              inputmode="decimal"
              step=".01"
              id="valorDinheiro"
              value="valorDinheiro"
              v-model="valorDinheiro"
              class="form-control"
              placeholder="Troco para:"
            />
          </div>
        </div>
      </div>
      <div class="spinner-border" role="status" v-else>
        <span class="sr-only">Loading...</span>
      </div>

      <br />
      <div style="display: block">
        <input
          style="width: 120px"
          type="text"
          id="cupom"
          value="cupom"
          v-model="cupom"
          class="form-control"
          placeholder="cupom"
        />
        <button
          style="
            align-items: center;
            margin-top: 5px;
            background-color: #006400;
          "
          class="btn btn-dark"
          @click="verificaCupom(cupom)"
        >
          Ativar Cupom
        </button>
      </div>
    </section>
    <br />
    <div
      style="
        display: flex;
        justify-content: center;
        align-items: start;
        flex-direction: column;
      "
      v-if="cdAgendamento == 1"
    >
      <button
        :style="{
          alignItems: 'center',
          width: '100%',
          marginTop: '5px',
          marginBottom: '5px',
          backgroundColor: corBotao,
          color: corTexto,
        }"
        class="btn btn-dark"
      >
        Agendamentor pedido
      </button>
      <br />
      <div style="display: flex">
        <input
          type="checkbox"
          id="agendamento"
          value="agendamento"
          v-model="checkedAgendamento"
          style="accent-color: #000; margin-right: 8px"
        />
        <label for="agendamento">Deseja agedar seu pedido? </label>
      </div>
      <div
        v-if="checkedAgendamento.length > 0"
        style="
          display: flex;
          justify-content: center;
          align-items: start;
          flex-direction: column;
        "
      >
        <input
          style="padding: 8px"
          type="datetime-local"
          v-model="dataAgendamento"
          id="dataencomenda"
          name="dataencomenda"
          class="custom-datetime"
          :min="minDateTime"
        />
      </div>
      <br />
    </div>
    <div style="display: flex; align-items: center; justify-content: flex-end">
      <label v-if="taxa == ''">Valor total: R$ {{ total.toFixed(2) }}</label>
      <label v-else
        >Valor total: R$ {{ (total + parseFloat(taxa)).toFixed(2) }}</label
      >
    </div>
    <div
      style="
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #8b0000;
      "
    >
      <div
        style="display: flex; align-items: center; justify-content: flex-end"
      >
        <button
          style="
            align-items: center;
            margin-top: 5px;
            margin-bottom: 5px;
            margin-right: 5px;
            background-color: #dc3545;
          "
          class="btn btn-dark"
          @click="pushSair()"
        >
          Sair
        </button>
      </div>
      <button
        style="
          align-items: center;
          margin-top: 5px;
          margin-bottom: 5px;
          background-color: #006400;
        "
        :disabled="isDisabled"
        class="btn btn-dark"
        @click="salvarVenda(products, cd_usuario)"
      >
        Finalizar pedido
      </button>
    </div>
    <br />
  </div>
</template>
<style>
.botao {
  display: flex;
  align-items: center;
  margin-top: 5px;
  margin-bottom: 5px;
}
.custom-datetime {
  padding: 10px;
  border: 2px solid #545454; /* Borda azul */
  border-radius: 5px; /* Arredondar os cantos */
  font-size: 16px; /* Tamanho da fonte */
  color: #545454; /* Cor do texto */
  background-color: #f0f0f0; /* Fundo mais claro */
  transition: border-color 0.3s, box-shadow 0.3s; /* Suavizar a transição de borda e sombra */
}

.custom-datetime:focus {
  border-color: #545454; /* Borda azul mais escura ao focar */
  box-shadow: 0 0 5px rgba(84, 84, 84, 0.5); /* Sombra ao focar */
  outline: none; /* Remover contorno padrão */
}

.custom-datetime::-webkit-calendar-picker-indicator {
  background-color: #f0f0f0; /* Cor do ícone do calendário */
  padding: 5px;
  border-radius: 50%;
}
</style>

<script>
import { mapGetters, mapActions } from "vuex";
import Cupom from "../services/cupom";
import Inis from "../services/inis";
import Usuario from "../services/usuario";
import Endereco from "../services/endereco";
import Venda from "../services/venda";
import Cardapio from "../services/cardapio";
import Swal from "sweetalert2";
import Bandeira from "../services/bandeira";
import moment from "moment";

export default {
  name: "FinalizadoLogin",
  data() {
    return {
      msgEntrega: "",
      msgRetirada: "",
      msgBuscaFone: "",
      estado: "",
      cidade: "",
      bairro: "",
      rua: "",
      numero: "",
      complemento: "",
      referencia: "",
      email: "",
      enderecos: {},
      cd_usuario: "",
      usuarios: [],
      cd: "",
      pagamento: "",
      checkedEndereco: "",
      taxa: "",
      endereco_cd: "",
      inis_valores: [],
      inis_valor: [],
      inis: {
        cd: "",
        vl: "",
        dt_ins: "",
        desc_config: "",
      },
      vendaspedidos: [],
      vendas: [],
      venda: {
        cd: "",
        total: "",
        dt: "",
        cd_usu: "",
        status: "",
        forma: "",
        troco: "",
        taxa: "",
        vl_desc: "",
      },
      telefone: "",
      corBotao: "",
      corTexto: "",
      corFundo: "",
      nomecompleto: "",
      valorDinheiro: "",
      valorTotal: "",
      valorTroco: 0,
      retirarBoolean: false,
      retirarLocalInis: true,
      somenteRetirada: false,
      valorMinimo: 0,
      cupom: "",
      desconto: {},
      jaUsado: "",
      quantidade: "",
      estoque: "",
      quantidadeInvalida: false,
      qtd: [],
      quantidadeArray: [],
      cupomAux: "",
      cupomAtivado: false,
      bandeiras: [],
      spinnerEndereco: true,
      spinnerCartao: true,
      win: "",
      idPixel: "",
      cadastro: "",
      cel: "",
      isDisabled: false,
      dataAgendamento: "",
      cdAgendamento: -1,
      checkedAgendamento: [],
      minDateTime: "",
    };
  },
  computed: {
    ...mapGetters({
      products: "cartProducts",
      logado: "retornaLogado",
    }),
    total() {
      var desconto;
      var somatorio = 0;
      var valor = 0;

      for (var i = 0; i < this.products.length; i++) {
        console.log(this.products[i].peso);
        if (this.products[i].peso) {
          valor = parseFloat(this.products[i].peso) * this.products[i].vl;
        } else {
          valor = this.products[i].vl * this.products[i].quantity;
        }
        somatorio = somatorio + valor;
      }

      this.valorTotal = somatorio;

      if (this.desconto.tipo == "V") {
        desconto = this.desconto.valor;
        return (this.valorTotal = this.valorTotal - parseFloat(desconto));
      } else if (this.desconto.tipo == "P") {
        desconto = (this.valorTotal * parseFloat(this.desconto.valor)) / 100;
        return (this.valorTotal = this.valorTotal - desconto);
      } else {
        return this.valorTotal;
      }
    },
    buscaTroco() {
      var troco;
      if (this.pagamento == "dinheiro") {
        /* if (this.taxa == "") {
           - parseFloat(this.valorTotal);
          
        } else {
          troco = parseFloat(this.valorDinheiro) - (parseFloat(this.valorTotal) + parseFloat(this.taxa));
          
        } */
        troco = parseFloat(this.valorDinheiro);
        if (troco == 0) {
          return (troco = "Não precisa de troco");
        } else {
          troco = parseFloat(troco).toFixed(2);
          this.valorTroco = troco;
          return troco;
        }
      } else {
        return (troco = "Não precisa de troco");
      }
    },
  },
  methods: {
    pushSair() {
      localStorage.removeItem("email" + localStorage.getItem("contrato"));
      localStorage.removeItem("nm" + localStorage.getItem("contrato"));
      localStorage.removeItem("cd" + localStorage.getItem("contrato"));
      this.$store.commit("setLogado", false);

      this.$router.push("/login");
    },
    push() {
      this.email = localStorage.getItem(
        "email" + localStorage.getItem("contrato")
      );
      this.cel = localStorage.getItem(
        "telefone" + localStorage.getItem("contrato")
      );
      this.$router.push("/endereco");
    },
    pushEnderecos() {
      this.$router.push("/endereco");
    },
    listarInisValorMinimo() {
      var cd = "VL_MIN_PEDIDO";
      Inis.listarInisCd(cd).then((resposta) => {
        this.valorMinimo = resposta.data[0].vl;
      });
    },
    async listandoEnderecos() {
      var endereco = await Endereco.listandoEnderecos(
        localStorage.getItem("cd" + localStorage.getItem("contrato"))
      );
      this.enderecos = endereco.data;
      if (this.cadastro != 3) {
        var usuario = await Usuario.getByEmail(this.email);
        this.usuarios = usuario.data;
        this.cd_usuario = usuario.data[0].cd;
        this.nomecompleto = usuario.data[0].nm;
        this.telefone = usuario.data[0].fone;
        this.retirarBoolean = true;
        this.spinnerEndereco = false;
      } else {
        var usuario = await Usuario.getByFone(this.cel);
        this.usuarios = usuario.data;
        this.cd_usuario = usuario.data[0].cd;
        this.nomecompleto = usuario.data[0].nm;
        this.telefone = usuario.data[0].fone;
        this.retirarBoolean = true;
        this.spinnerEndereco = false;
      }
    },
    /*.then((resposta) => {
          this.usuarios = resposta.data;
          this.usuarios.forEach((usuario) => {
            if (this.cadastro != 3) {
              if (usuario.email == this.email) {
                this.cd_usuario = usuario.cd;
                this.nomecompleto = usuario.nm;
                this.telefone = usuario.fone;
                this.retirarBoolean = true;
                this.spinnerEndereco = false;
              }
            } else {
              console.log(usuario.fone == this.cel)
              console.log(usuario.fone)
              console.log(this.cel)
              if (usuario.fone == this.cel) {
                this.cd_usuario = usuario.cd;
                this.nomecompleto = usuario.nm;
                this.telefone = usuario.fone;
                this.retirarBoolean = true;
                this.spinnerEndereco = false;
              }
            }
          });
        });*/
    async verificaCupom(cupom) {
      if (this.cupomAtivado == true) {
        Swal.fire({
          title: "Um cupom já foi aplicado",
          confirmButtonColor: "#000000",
        });
      } else {
        Cupom.verificacupom(cupom).then((resposta) => {
          this.cupomAux = resposta.data;
          if (resposta.data == null) {
            Swal.fire({
              title: "Cupom inexistente",
              confirmButtonColor: "#000000",
            });
          } else {
            Cupom.verificacupomusado(this.cd_usuario, this.cupomAux[0].cd).then(
              (resposta) => {
                this.jaUsado = resposta.data;
                if (this.cupomAux[0].repetivel == "1") {
                  this.jaUsado = null;
                }
                if (this.jaUsado != null) {
                  Swal.fire({
                    title: "Cupom já utilizado",
                    confirmButtonColor: "#000000",
                  });
                } else {
                  if (parseFloat(this.cupomAux[0].vl_min) > this.total) {
                    Swal.fire({
                      title:
                        "Valor mínimo de " +
                        this.cupomAux.vl_min +
                        " reais para usar o cupom",
                      confirmButtonColor: "#000000",
                    });
                  } else {
                    this.desconto = {
                      tipo: this.cupomAux[0].tipo,
                      valor: this.cupomAux[0].valor,
                      cd: this.cupomAux[0].cd,
                      qtd: this.cupomAux[0].qtd,
                    };

                    Swal.fire({
                      title: "Cupom aprovado",
                      confirmButtonColor: "#000000",
                    });
                    this.cupomAtivado = true;
                  }
                }
              }
            );
          }
        });
        this.jaUsado = "";
      }
    },
    codigoEndereco(cd) {
      this.endereco_cd = cd;
    },
    salvarEndereco(endereco) {
      this.estado = endereco.uf;
      this.cidade = endereco.nm_cid;
      this.bairro = endereco.bairro;
      this.rua = endereco.rua;
      this.numero = endereco.numero;
      this.complemento = endereco.complemento;
      this.referencia = endereco.proximidade;
    },
    taxaBairro(taxa) {
      this.taxa = parseFloat(taxa).toFixed(2);
      taxa = parseFloat(taxa).toFixed(2);
      return taxa;
    },

    retornar_cd_endereco(cd) {
      this.cd = cd;
    },
    async listarBandeiras() {
      await Bandeira.listarbandeiras().then((resposta) => {
        this.bandeiras = resposta.data.filter((bandeira) => {
          if (bandeira.ativo == "1") {
            return bandeira;
          }
        });
      });
      this.spinnerCartao = false;
    },
    listarpedidosvenda(venda) {
      console.log("Passou aqui");
      Venda.listarpedidosvenda().then((resposta) => {
        this.vendaspedidos = resposta.data;
        //alert(JSON.stringify(this.vendaspedidos[0]));
      });
    },
    listandoInisEstoque() {
      var cd = "CONTROLA_ESTOQUE";
      Inis.listarInisCd(cd).then((resposta) => {
        this.estoque = resposta.data[0].vl;
      });
    },
    async listandoInisRetirarLocal() {
      var cd = "RETIRAR_LOCAL";
      await Inis.listarInisCd(cd).then((resposta) => {
        if (resposta.data[0].vl == 0) {
          this.retirarLocalInis = false;
        } else if (resposta.data[0].vl == 1) {
          this.retirarLocalInis = true;
        }
      });
    },
    async listandoInisSomenteRetirada() {
      var cd = "SOMENTE_RETIRADA";
      await Inis.listarInisCd(cd).then((resposta) => {
        if (resposta.data[0].vl == 0) {
          this.somenteRetirada = false;
        } else if (resposta.data[0].vl == 1) {
          this.somenteRetirada = true;
        }
      });
    },
    //listarinisvalores
    listarinisvalores() {
      Inis.listarinisvalores().then((resposta) => {
        this.inis_valores = resposta.data;
        //alert(resposta.data);
      });
    },
    //listarinis
    listarinis() {
      Inis.listarinis().then((resposta) => {
        this.inis_valor = resposta.data;
      });
      var cd = "Cor_primaria";
      Inis.listarInisCd(cd).then((resposta) => {
        this.corFundo = resposta.data[0].vl;
      });
      var cd = "Cor_secundaria";
      Inis.listarInisCd(cd).then((resposta) => {
        this.corBotao = resposta.data[0].vl;
      });
      var cd = "Cor_tercearia";
      Inis.listarInisCd(cd).then((resposta) => {
        this.corTexto = resposta.data[0].vl;
      });
      var cd = "TIPO_LOGIN";
      Inis.listarInisCd(cd).then((resposta) => {
        this.cadastro = resposta.data[0].vl;
      });
      var cd = "ID_PIXEL";
      Inis.listarInisCd(cd).then((response) => {
        this.idPixel = response.data[0].vl;
        if (this.idPixel != "") {
          this.loadFacebookPixel(this.idPixel, "InitiateCheckout", "");
        }
      });
      var cd = "AGENDAMENTO";
      Inis.listarInisCd(cd).then((resposta) => {
        this.cdAgendamento = resposta.data[0].vl;
      });
    },
    buscacodigo() {
      var mesge = "";
      var cd = "";
      var maisum = "1";

      if (this.vendaspedidos[0] && this.vendaspedidos[0].cd) {
        Venda.buscacodigo().then((resposta) => {
          this.vendaspedidos = resposta.data;
        });
        mesge = (
          parseFloat(this.vendaspedidos[0].cd) + parseFloat(maisum)
        ).toFixed(0);
      }

      return mesge;
    },
    buscafone() {
      var cdf = "WHATSAPP";

      var msge = "";

      Inis.buscafone(cdf).then((resposta) => {
        this.inis_valor = resposta.data;
        // console.log(this.inis_valor, "this.inis_valor");
        this.msgBuscaFone = this.inis_valor[0].vl;
        //  console.log(this.msgBuscaFone, "this.msgBuscaFone");
      });

      // msge = this.inis_valor[0].vl;
      // console.log(msge, "msge");

      //alert(JSON.stringify(this.inis_valor[0].vl));
    },
    getMsgPedido() {
      const data = new Date(this.dataAgendamento);
      const dataFormatted = data.toLocaleDateString("pt-BR");
      const timeFormatted = data.toLocaleTimeString("pt-BR", {
        hour: "2-digit",
        minute: "2-digit",
      });

      if (this.endereco_cd == "retirarLocal") {
        this.msgRetirada = `Tempo agendado para retirada: ${dataFormatted} às ${timeFormatted}`;
      } else {
        this.msgEntrega = `Tempo agendado para entrega: ${dataFormatted} às ${timeFormatted}`;
      }
    },
    buscaentrega() {
      var cde = "TEMPO_ENTREGA";

      Inis.buscaentrega(cde).then((resposta) => {
        this.inis_valores = resposta.data;
        this.msgEntrega = this.inis_valores[0].vl;
      });
    },
    buscaretirada() {
      var cdr = "TEMPO_RETIRADA";
      var vl = "";

      Inis.buscaretirada(cdr).then((resposta) => {
        this.inis_valores = resposta.data;
        this.msgRetirada = this.inis_valores[0].vl;
      });
    },

    buscavalor(preco) {
      var somatorio = 0;
      var valor = 0;

      for (var i = 0; i < this.products.length; i++) {
        if (this.products[i].peso) {
          valor = parseFloat(this.products[i].peso) * this.products[i].vl;
        } else {
          valor = this.products[i].vl * this.products[i].quantity;
        }
        somatorio = somatorio + valor;
      }
      return somatorio;
    },

    whatsapp(itens) {
      let retorno = "";

      for (const [index, item] of itens.entries()) {
        let listaAdicionais = "";

        if (item.adicionaispergunta && item.adicionaispergunta.length > 0) {
          listaAdicionais =
            "- " +
            item.adicionaispergunta
              .map((adicionais) => adicionais.nm.trim())
              .join(", ") +
            ", ";
        }
        if (item.obs != "" && itens.length - 1 == index) {
          listaAdicionais += item.obs;
        }

        retorno += `${parseInt(item.quantity)}x ${
          item.nm
        } ${listaAdicionais}%0A`;
      }

      return retorno;
    },

    menosqtd(p) {
      if (p.quantity >= "2") {
        p.quantity -= 1;
      } else {
        Swal.fire({
          title: "Obrigatório ter pelo menos um item desse produto.",
          confirmButtonColor: "#000000",
        });
      }
    },
    somatorio() {
      var somatorio = 0;
      var valor = 0;

      for (var i = 0; i < this.products.length; i++) {
        if (this.products[i].peso) {
          valor = parseFloat(this.products[i].peso) * this.products[i].vl;
        } else {
          valor = this.products[i].vl * this.products[i].quantity;
        }
        somatorio = somatorio + valor;
      }
      return somatorio;
    },

    somarqtd(p) {
      p.quantity += 1;
      //alert(JSON.stringify(index));
    },

    del(index) {
      this.products.splice(index, 1);
    },
    deletarEndereco() {
      var e = new Object();
      e.cd = this.codigoEndereco;
      Endereco.deletarEnderecos(e).then(function (response) {
        Swal.fire({ title: response.data, confirmButtonColor: "#000000" });
      });
    },
    loadFacebookPixel(idPixel, type, total) {
      // Crie o elemento <script> para carregar o Pixel
      var script = document.createElement("script");
      script.src = "https://connect.facebook.net/en_US/fbevents.js";
      script.async = true;

      // Adicione o Pixel ID à chamada de inicialização do Pixel
      var initCode = 'fbq("init", "' + idPixel + '");';

      // Crie o elemento <noscript> para o caso de o usuário não ter JavaScript habilitado
      var noscript = document.createElement("noscript");
      var img = document.createElement("img");
      img.height = 1;
      img.width = 1;
      img.style.display = "none";
      if (total == "") {
        img.src =
          "https://www.facebook.com/tr?id=" +
          idPixel +
          `&ev=${type}&noscript=1`;
      } else {
        img.src =
          "https://www.facebook.com/tr?id=" +
          idPixel +
          `&ev=${type}&noscript=1` +
          "&cd[value]=" +
          total.toFixed(2) +
          "&cd[currency]=BRL";
      }

      // Adicione o código de inicialização ao elemento <noscript>
      noscript.appendChild(document.createTextNode(initCode));
      noscript.appendChild(img);

      // Adicione os elementos ao DOM
      document.head.appendChild(script);
      document.head.appendChild(noscript);
    },
    async salvarVenda(products, cd_usuario) {
      try {
        this.isDisabled = true;
        if (!(await this.validarCampos())) {
          this.isDisabled = false;
          return false;
        }
        if (
          !this.validateSelectedTime() &&
          this.checkedAgendamento.length > 0
        ) {
          await Swal.fire({
            title: "Horário inválido",
            confirmButtonColor: "#000000",
          });
          this.isDisabled = false;
          return false;
        }
        var u = new Object();
        u.cd_endereco = this.cd;
        u.cd_usuario = cd_usuario;

        await Usuario.alterarusuario(u).catch(function (error) {
          alert(error);
        });

        var v = new Object();

        v.cd_usuario = cd_usuario;
        v.forma = this.pagamento;
        v.taxa = this.taxa;
        v.mesa = null;
        v.serie = null;
        v.num_serie = null;
        if (this.checkedAgendamento.length > 0) {
          v.dt = this.dataAgendamento.replace("T", " ");
          this.getMsgPedido()
        }

        if (this.valorDinheiro == "") {
          v.troco = null;
        } else {
          v.troco = this.valorDinheiro;
        }

        v.total = this.somatorio();
        if (!(await this.validarCamposValor(v))) {
          this.isDisabled = false;
          return false;
        }
        if (this.desconto.tipo == "V") {
          v.desconto = this.desconto.valor;
        } else if (this.desconto.tipo == "P") {
          v.desconto = (
            (parseFloat(v.total) * parseFloat(this.desconto.valor)) /
            100
          ).toFixed(2);
        } else {
          v.desconto = "0.00";
        }
        v.total = parseFloat(v.total).toFixed(2);
        v.products = products.map((produto) => {
          if (produto.unitario == "0") {
            produto.quantity = produto.peso;
          }
          return produto;
        });

        var c = new Object();

        c.cd_usuario = cd_usuario;
        c.cd_cupom = this.desconto.cd;

        Cupom.registracupom(c);

        var cupomQtd = new Object();

        cupomQtd.cd_cupom = this.desconto.cd;
        cupomQtd.qtd = parseInt(this.desconto.qtd) - 1;

        Cupom.atualizaqtd(cupomQtd);

        if (this.estoque == "1") {
          const valores = products.map((prod) => ({
            cd: prod.cd,
            qt: prod.quantity,
          }));

          const quantidadeMap = valores.reduce((acc, { cd, qt }) => {
            acc[cd] = (acc[cd] || 0) + parseInt(qt);
            return acc;
          }, {});

          this.qtd = products.map((prod) => quantidadeMap[prod.cd]);

          const promises = products.map((produto) =>
            Cardapio.listarQtd(produto.cd).then((resposta) =>
              parseFloat(resposta.data[0].estoque)
            )
          );

          this.quantidadeArray = await Promise.all(promises);

          for (let i = 0; i < products.length; i++) {
            const produto = products[i];
            if (this.qtd[i] > this.quantidadeArray[i]) {
              await Swal.fire({
                title: `Produto ${produto.nm} tem no máximo ${this.quantidadeArray[i]} unidades restantes`,
                confirmButtonColor: "#000000",
              });
              this.quantidadeInvalida = true;
              break;
            } else {
              const e = {
                cd: produto.cd,
                qtd: this.quantidadeArray[i] - this.qtd[i],
              };
              await Cardapio.alteraQtd(e);
            }
          }
        }

        if (this.quantidadeInvalida == true) {
          this.isDisabled = false;
          return false;
        }

        await Venda.salvarvenda(v)
          .then(function (response) {
            Swal.fire({
              scrollbarPadding: false,
              title: response.data,
              confirmButtonColor: "#000000",
            });
          })
          .catch(function (error) {
            alert(error);
          });
        if (this.idPixel != "") {
          this.loadFacebookPixel(this.idPixel, "Purchase", this.total);
        }
        if (this.endereco_cd == "retirarLocal") {
          this.tipo = "Retirada no local";

          var win = window.open(
            "https://api.whatsapp.com/send?phone=" +
              this.msgBuscaFone +
              "&text=*Pedido%20Pantera%20Food%20Deli:%20" +
              this.buscacodigo(this.vendaspedidos) +
              "*%0A---------------------------------------%0A%0A" +
              this.whatsapp(this.products) +
              "%0A* Total:%20R$%20" +
              this.total.toFixed(2) +
              "*%0A%0A---------------------------------------%0A%0A*Troco para:*%20" +
              this.buscaTroco +
              "*%0A%0A---------------------------------------%0A%0A*Pagamento:*%20" +
              this.pagamento +
              "%0A%0A---------------------------------------%0A%0A*" +
              this.nomecompleto +
              "*%0A" +
              this.telefone +
              "%0A%0A---------------------------------------%0A%0A*" +
              this.tipo +
              "%20no%20local*%0A%0A---------------------------------------%0A%0A*" +
              this.msgRetirada +
              "*",
            "_blank"
          );
          if (win == null || win == undefined) {
            var win = window.location.assign(
              "https://api.whatsapp.com/send?phone=" +
                this.msgBuscaFone +
                "&text=*Pedido%20Pantera%20Food%20Deli:%20" +
                this.buscacodigo(this.vendaspedidos) +
                "*%0A---------------------------------------%0A%0A" +
                this.whatsapp(this.products) +
                "%0A* Total:%20R$%20" +
                this.total.toFixed(2) +
                "*%0A%0A---------------------------------------%0A%0A*Troco para:*%20" +
                this.buscaTroco +
                "*%0A%0A---------------------------------------%0A%0A*Pagamento:*%20" +
                this.pagamento +
                "%0A%0A---------------------------------------%0A%0A*" +
                this.nomecompleto +
                "*%0A" +
                this.telefone +
                "%0A%0A---------------------------------------%0A%0A*" +
                this.tipo +
                "%20no%20local*%0A%0A---------------------------------------%0A%0A*" +
                this.msgRetirada +
                "*"
            );
          }

          this.$store.commit("setZera", []);
          /*             this.$store.commit("added", []);
            this.$store.commit("addedadi", []); */
          this.$router.push("/");
          /* this.home(); */
        } else {
          this.tipo = "Entrega";

          var win = window.open(
            "https://api.whatsapp.com/send?phone=" +
              this.msgBuscaFone +
              "&text=*Pedido%20Pantera%20Food%20Deli:%20" +
              this.buscacodigo(this.vendaspedidos) +
              "*%0A---------------------------------------%0A%0A" +
              this.whatsapp(this.products) +
              "%0A*Produtos:%20R$%20" +
              this.total.toFixed(2) +
              "*%0A" +
              "%0A*Taxa de entrega:%20R$%20" +
              parseFloat(this.taxa).toFixed(2) +
              "*%0A" +
              "%0A*Total:%20R$%20" +
              (parseFloat(this.total) + parseFloat(this.taxa)).toFixed(2) +
              "*%0A%0A---------------------------------------%0A%0A*Troco para:*%20" +
              this.buscaTroco +
              "*%0A%0A---------------------------------------%0A%0A*Pagamento:*%20" +
              this.pagamento +
              "%0A%0A---------------------------------------%0A%0A*" +
              this.nomecompleto +
              "*%0A" +
              this.telefone +
              "%0A%0A---------------------------------------%0A%0A*" +
              this.tipo +
              "*%0A*Cidade:*%20" +
              this.cidade +
              "%0A*Estado:*%20" +
              this.estado +
              "%0A*Bairro:*%20" +
              this.bairro +
              "%0A*Rua:*%20" +
              this.rua +
              "%0A*Complemento:*%20" +
              this.complemento +
              "%0A*Referência:*%20" +
              this.referencia +
              "%0A%0A---------------------------------------%0A%0A*" +
              this.msgEntrega +
              "*"
          );
          if (win == null || win == undefined) {
            var win = window.location.assign(
              "https://api.whatsapp.com/send?phone=" +
                this.msgBuscaFone +
                "&text=*Pedido%20Pantera%20Food%20Deli:%20" +
                this.buscacodigo(this.vendaspedidos) +
                "*%0A---------------------------------------%0A%0A" +
                this.whatsapp(this.products) +
                "%0A*Produtos:%20R$%20" +
                this.total.toFixed(2) +
                "*%0A" +
                "%0A*Taxa de entrega:%20R$%20" +
                parseFloat(this.taxa).toFixed(2) +
                "*%0A" +
                "%0A*Total:%20R$%20" +
                (parseFloat(this.total) + parseFloat(this.taxa)).toFixed(2) +
                "*%0A%0A---------------------------------------%0A%0A*Troco para:*%20" +
                this.buscaTroco +
                "*%0A%0A---------------------------------------%0A%0A*Pagamento:*%20" +
                this.pagamento +
                "%0A%0A---------------------------------------%0A%0A*" +
                this.nomecompleto +
                "*%0A" +
                this.telefone +
                "%0A%0A---------------------------------------%0A%0A*" +
                this.tipo +
                "*%0A*Cidade:*%20" +
                this.cidade +
                "%0A*Estado:*%20" +
                this.estado +
                "%0A*Bairro:*%20" +
                this.bairro +
                "%0A*Rua:*%20" +
                this.rua +
                "%0A*Complemento:*%20" +
                this.complemento +
                "%0A*Referência:*%20" +
                this.referencia +
                "%0A%0A---------------------------------------%0A%0A*" +
                this.msgEntrega +
                "*"
            );
          }
          this.$store.commit("setZera", []);
          /* this.$store.commit("added", []);
            this.$store.commit("addedadi", []); */
          this.$router.push("/");
          /* this.home(); */
        }
      } catch (err) {
        this.isDisabled = false;
      }
    },
    async validarCampos() {
      console.log(typeof this.endereco_cd)
      console.log(typeof "")
      const campos = [
        {
          condicao: this.taxa === "",
          mensagem: "Por favor, selecione o seu endereço.",
        },
        {
          condicao:
            this.endereco_cd !== "retirarLocal" && this.endereco_cd === "",
          mensagem: "Por favor, selecione uma forma de entrega.",
        },
        {
          condicao:
            this.enderecos === null && this.endereco_cd !== "retirarLocal",
          mensagem: "Por favor, selecione uma forma de entrega.",
        },
        {
          condicao: this.pagamento === "",
          mensagem: "Por favor, selecione forma de pagamento.",
        },
        {
          condicao: this.pagamento === "dinheiro" && this.valorDinheiro === "",
          mensagem: "Por favor, digite valor em dinheiro.",
        },
      ];

      // Verifica cada campo e exibe a mensagem apropriada se necessário
      for (const { condicao, mensagem } of campos) {
        if (condicao) {
          await Swal.fire({
            title: mensagem,
            confirmButtonColor: "#000000",
          });
          return false;
        }
      }

      // Se todos os campos forem válidos, retorne true
      return true;
    },
    async validarCamposValor(v) {
      // Defina todos os campos e suas respectivas mensagens de erro

      const campos = [
        {
          condicao: this.taxa === "",
          mensagem: "Por favor, selecione o seu endereço.",
        },
        {
          condicao:
            this.endereco_cd !== "retirarLocal" && this.endereco_cd ==="",
          mensagem: "Por favor, selecione uma forma de entrega.",
        },
        {
          condicao:
            this.enderecos === null && this.endereco_cd !== "retirarLocal",
          mensagem: "Por favor, selecione uma forma de entrega.",
        },
        {
          condicao: this.pagamento === "",
          mensagem: "Por favor, selecione forma de pagamento.",
        },
        {
          condicao: this.pagamento === "dinheiro" && this.valorDinheiro === "",
          mensagem: "Por favor, digite valor em dinheiro.",
        },
        {
          condicao: v.total === "0.00",
          mensagem: "Por favor, selecione um produto.",
        },
        {
          condicao: parseFloat(this.valorMinimo) > parseFloat(v.total),
          mensagem: `O valor mínimo de compra é: ${this.valorMinimo} reais`,
        },
      ];

      // Verifica cada campo e exibe a mensagem apropriada se necessário
      for (const { condicao, mensagem } of campos) {
        if (condicao) {
          await Swal.fire({
            title: mensagem,
            confirmButtonColor: "#000000",
          });
          return false;
        }
      }

      // Se todos os campos forem válidos, retorne true
      return true;
    },
    setDate() {
      const currentDate = new Date();

      const year = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, "0");
      const day = String(currentDate.getDate()).padStart(2, "0");

      const hours = String(currentDate.getHours()).padStart(2, "0");
      const minutes = String(currentDate.getMinutes()).padStart(2, "0");

      this.dataAgendamento = `${year}-${month}-${day}T${hours}:${minutes}`;
      this.minDateTime = `${year}-${month}-${day}T${hours}:${minutes}`;
    },
    validateSelectedTime() {
      const currentTimeInt = Date.now();

      var selectedTime = JSON.parse(JSON.stringify(this.dataAgendamento));

      const selectedTimeInt = new Date(selectedTime).getTime();

      if (currentTimeInt > selectedTimeInt) {
        return false;
      }
      return true;
    },
  },
  created() {
    if (this.logado == false) {
      this.$router.push("/login");
    }
  },
  mounted() {
    this.setDate(),
      this.listandoInisEstoque(),
      this.listarBandeiras(),
      this.listarInisValorMinimo(),
      this.listarinis(),
      this.listarinisvalores(),
      this.buscafone(),
      this.buscacodigo(),
      this.buscaretirada(),
      this.buscaentrega(),
      this.listarpedidosvenda(),
      this.listandoInisRetirarLocal(),
      this.listandoInisSomenteRetirada(),
      this.listandoEnderecos(),
      (this.email = localStorage.getItem(
        "email" + localStorage.getItem("contrato")
      ));
    this.cel = localStorage.getItem(
      "telefone" + localStorage.getItem("contrato")
    );
  },
};
</script>